/**
 * useUniversePhone — returns the phone number for the active universe.
 * Falls back to the global settings phone when the universe doesn't define one.
 * NON-CORE FILE — additive customization for the Jardins d'Éole client only.
 */
import { useUniverse } from "@/lib/jardins-ole/useUniverse";
import { useSettings } from "@/lib/useSettings";

export default function useUniversePhone() {
  const { config, enabled } = useUniverse();
  const { settings } = useSettings();
  if (enabled && config?.phone) return config.phone;
  return settings?.phone || "";
}
